export interface IRoute {
  link: string;
  title: string;
  inMenu: boolean;
  badged?: boolean;
  createLink?: (id: string) => string;
}

export const Routes: {
  [key: string]: IRoute;
} = {
  DASHBOARD: {
    link: '/',
    title: 'Dashboard',
    inMenu: true,
  },
  ENQUIRIES: { link: '/enquiries', title: 'Enquiries', inMenu: true, badged: true },
  ENQUIRY: { link: '/enquiries/:id', title: 'Enquiry', inMenu: false },
  PRODUCTS: { link: '/products', title: 'Products', inMenu: true },
  PRODUCT_SELECTORS: {
    link: '/products/selectors',
    title: 'Product Selectors',
    inMenu: true,
  },
  PRODUCT_SELECTOR: {
    link: '/products/selectors/:id',
    title: 'Product Selector',
    inMenu: false,
    createLink: (id: string) => {
      return `/products/selectors/${id}`;
    },
  },
  PRODUCT: {
    link: '/products/:id',
    createLink: (id: string) => {
      return `/products/${id}`;
    },
    title: 'Products',
    inMenu: false,
  },
  COUPONS: { link: '/coupons', title: 'Coupons', inMenu: true },
  COUPON: {
    link: '/coupons/:id/*',
    title: 'Coupon',
    inMenu: false,
    createLink: (id: string) => {
      return `/coupons/${id}`;
    },
  },
  ORDERS: {
    link: '/orders',
    title: 'Orders',
    inMenu: true,
    badged: true,
  },
  ORDER: {
    link: '/orders/:id',
    title: 'Order',
    inMenu: false,
    createLink: (id: string) => {
      return `/orders/${id}`;
    },
  },
  ALBUM: {
    link: '/albums/:id/*',
    title: 'Album',
    inMenu: false,
    createLink: (id: string) => {
      return `/albums/${id}`;
    },
  },
  EVENTS: { link: '/events', title: 'Events', inMenu: true },
  EVENT: {
    link: '/events/:id/*',
    title: 'Event',
    inMenu: false,
    createLink: (id: string) => {
      return `/events/${id}`;
    },
  },
  USERS: { link: '/users', title: 'Users', inMenu: true },
  USER: {
    link: '/users/:id',
    title: 'User',
    inMenu: false,
    createLink: (id: string) => {
      return `/users/${id}`;
    },
  },
  STAGING: { link: '/staging', title: 'Staging', inMenu: true, badged: true },
  TASKS: { link: '/tasks', title: 'Tasks', inMenu: true },
  TASK: {
    link: '/tasks/:id',
    title: 'Task',
    inMenu: false,
    createLink: (id: string) => {
      return `/tasks/${id}`;
    },
  },
  ARCHIVES: { link: '/archives', title: 'Archives', inMenu: false },
  SETTINGS: { link: '/settings/*', title: 'Settings', inMenu: false },
  SETTING: { link: '/settings', title: 'Settings', inMenu: true },
  LOGIN: { link: '/', title: 'Login', inMenu: false },
  SWITCHACCOUNT: {
    link: '/switch-account',
    title: 'Switch Account',
    inMenu: false,
  },
  FORGOTTEN: {
    link: '/forgotten',
    title: 'Forgotten your password',
    inMenu: false,
  },
  RESETPASSWORD: {
    link: '/forgotten/reset/:token',
    title: 'Reset your password',
    inMenu: false,
  },
  DEBUG: {
    link: '/debug',
    title: 'Debug',
    inMenu: false,
  },
  REGISTER: { link: '/register', title: 'Register', inMenu: false },
};

export default Routes;
